export const OrderTypes = {
  EQUITY: "equity",
  OPTION: "option",
  MULTILEG: "multileg",
  COMBO: "combo",
  OTO: "oto",
  OCO: "oco",
  OTOCO: "otoco",
};
export const OrderSides = {
  B2O: "buy_to_open",
  B2C: "buy_to_close",
  S2O: "sell_to_open",
  S2C: "sell_to_close",
};
export const OrderMarket = {
  MARKET: "market",
  LIMIT: "limit",
  STOP: "stop",
  STOP_LIMIT: "stop_limit",
};
export const OrderDuration = {
  DAY: "day",
  GTC: "gtc",
  PRE: "pre",
  POST: "post",
};

export const ROLES = {
  ADMIN: "admin",
  MANAGER: "fundManager",
  CUSTOMER: "customer",
  ADVISOR: "advisor",
};
